import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./_guards/auth.guard";
import { SociosanitaryGuard } from "./_guards/sociosanitary.guard";
import { environment } from "src/environments/environment"
import { PublicRedirectionGuard } from "./_guards/public-redirection.guard";
import { FlowNavigationGuard } from "./_guards/flow-navigation.guard";

const routes: Routes = [
  // Public routes
  {
    path: "",
    redirectTo: "/" + environment.defaultLang,
    pathMatch: "full"
  },
  {
    path: ":locale",
    data: { title: "routeTitles.login" },
    loadChildren: () => import("./_modules/login/login.module").then( m => m.LoginPageModule),
    canActivate: [PublicRedirectionGuard]
  },
  {
    path: ":locale/recovery",
    data: { title: "routeTitles.recovery" },
    loadChildren: () => import("./_modules/recovery/recovery.module").then( m => m.RecoveryPageModule),
    canActivate: [PublicRedirectionGuard]
  },
  {
    path: ":locale/change-password/:token",
    data: { title: "routeTitles.changePassword" },
    loadChildren: () => import("./_modules/changepassword/changepassword.module").then( m => m.ChangepasswordPageModule),
    canActivate: [PublicRedirectionGuard]
  },
  {
    path: ":locale/santander-portugal-autologin-token",
    data: { title: "routeTitles.santanderPortugalAutologinToken" },
    loadChildren: () => import("./_modules/mock/auth-strategy/santander-portugal-autologin-token/santander-portugal-autologin-token.module").then( m => m.AutologinTokenPageModule),
    canActivate: [PublicRedirectionGuard]
  },
  // Protected routes
  {
    path: ":locale/about",
    data: { title: "routeTitles.about", type: "0" },
    loadChildren: () => import("./_modules/page-details/page-details.module").then(m => m.PageDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/beneficiaries",
    data: { title: "routeTitles.beneficiaries", type: "1" },
    loadChildren: () => import("./_modules/page-details/page-details.module").then(m => m.PageDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/faq",
    data: { title: "routeTitles.faq", type: "2" },
    loadChildren: () => import("./_modules/page-details/page-details.module").then(m => m.PageDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/id-4",
    data: { title: "routeTitles.id4", type: "3" },
    loadChildren: () => import("./_modules/page-details/page-details.module").then(m => m.PageDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/id-5",
    data: { title: "routeTitles.id5", type: "4" },
    loadChildren: () => import("./_modules/page-details/page-details.module").then(m => m.PageDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-index",
    data: { title: "routeTitles.serviceIndex" },
    loadChildren: () => import("./_modules/service-index/service-index.module").then( m => m.ServiceIndexPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-details/:id",
    data: { title: "routeTitles.serviceDetails" },
    loadChildren: () => import("./_modules/service-details/service-details.module").then( m => m.ServiceDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-availability/:id",
    data: { title: "routeTitles.serviceAvailability" },
    loadChildren: () => import("./_modules/service-availability/service-availability.module").then( m => m.ServiceAvailabilityPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-availability-static/:id",
    data: { title: "routeTitles.serviceAvailability" },
    loadChildren: () => import("./_modules/service-availability-static/service-availability-static.module").then( m => m.ServiceAvailabilityStaticPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-request/:id",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/service-request/service-request.module").then( m => m.ServiceRequestPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/contact",
    data: { title: "routeTitles.contact" },
    loadChildren: () => import("./_modules/contact/contact.module").then( m => m.ContactPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/feature/:id",
    data: { title: "routeTitles.feature" },
    loadChildren: () => import("./_modules/feature/feature.module").then( m => m.FeaturePageModule),
    // canActivate: [AuthGuard]
  },
  {
    path: ":locale/sociosanitary",
    data: { title: "routeTitles.sociosanitary" },
    loadChildren: () => import("./_modules/sociosanitary/sociosanitary.module").then( m => m.SociosanitaryPageModule),
    canActivate: [SociosanitaryGuard, AuthGuard]
  },
  {
    path: ":locale/personal-area",
    data: { title: "routeTitles.personalArea" },
    loadChildren: () => import("./_modules/personal-area/personal-area-index/personal-area-index.module").then( m => m.PersonalAreaIndexPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/personal-area/my-data",
    data: { title: "routeTitles.personalAreaMyData" },
    loadChildren: () => import("./_modules/personal-area/user/user.module").then(m => m.UserPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/personal-area/my-services",
    data: { title: "routeTitles.personalAreaMyServices" },
    loadChildren: () => import("./_modules/personal-area/user-services/user-services.module").then( m => m.UserServicesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/personal-area/my-beneficiaries",
    data: { title: "routeTitles.personalAreaMyBeneficiaries" },
    loadChildren: () => import("./_modules/personal-area/beneficiary/beneficiary.module").then( m => m.BeneficiaryPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/personal-area/request-details/:id",
    data: { title: "routeTitles.personalAreaRequestDetails" },
    loadChildren: () => import("./_modules/personal-area/request-details/request-details.module").then( m => m.RequestDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/personal-area/stock-details/:publicUuid",
    data: { title: "routeTitles.personalAreaStockDetails" },
    loadChildren: () => import("./_modules/personal-area/stock-details/stock-details.module").then( m => m.StockDetailsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-request/:id/salas-vip/search-airport",
    data: { title: "routeTitles.vipSearchAirport" },
    loadChildren: () => import("./_modules/dragonpass/search-airport/search-airport.module").then( m => m.SearchAirportPageModule),
    canActivate: [FlowNavigationGuard, AuthGuard]
  },
  {
    path: ":locale/service-request/:id/salas-vip/terminal-details",
    data: { title: "routeTitles.vipTerminalDetails" },
    loadChildren: () => import("./_modules/dragonpass/terminal-details/terminal-details.module").then( m => m.TerminalDetailsPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/salas-vip/resource-details",
    data: { title: "routeTitles.vipResourceDetails" },
    loadChildren: () => import("./_modules/dragonpass/resource-details/resource-details.module").then( m => m.ResourceDetailsPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/salas-vip/check-availability",
    data: { title: "routeTitles.vipCheckAvailability" },
    loadChildren: () => import("./_modules/dragonpass/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/salas-vip/form",
    data: { title: "routeTitles.vipForm" },
    loadChildren: () => import("./_modules/forms/dragonpass/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/salas-vip-whatsapp/form",
    data: { title: "routeTitles.vipForm" },
    loadChildren: () => import("./_modules/forms/vip-room-whatsapp/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/fast-track/form",
    data: {title: "Detalle de recurso"},
    loadChildren: () => import("./_modules/forms/fast-track/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/beauty/form",
    data: {title: "Detalle de recurso"},
    loadChildren: () => import("./_modules/forms/beauty/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/hairdressing/form",
    data: { title: "routeTitles.hairdressingForm" },
    loadChildren: () => import("./_modules/forms/hairdressing/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/force-error",
    data: { title: "routeTitles.forceError" },
    loadChildren: () => import("./_modules/force-error/force-error.module").then( m => m.ForceErrorPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: ":locale/service-request/:id/esim-flag/check-availability",
    data: { title: "routeTitles.esimCheckAvailability" },
    loadChildren: () => import("./_modules/e-sim-flag/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/esim-flag/form",
    data: { title: "routeTitles.esimForm" },
    loadChildren: () => import("./_modules/forms/e-sim-flag/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/transfer/check-availability",
    data: { title: "routeTitles.transferCheckAvailability" },
    loadChildren: () => import("./_modules/transfer/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/transfer/form",
    data: { title: "routeTitles.transferForm" },
    loadChildren: () => import("./_modules/forms/transfer/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/transfer/uber-form",
    data: {title: "Formulario Transfer"},
    loadChildren: () => import("./_modules/forms/uber/uber-form.module").then( m => m.UberFormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/handyman/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "handyman",
        stockSessionKey: "handyman-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-generic-companions/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "experience-generic-companions",
        stockSessionKey: "experience-generic-companions-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-generic-companions/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/experience-generic-companions/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-exclusive-companions/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "experience-exclusive-companions",
        stockSessionKey: "experience-exclusive-companions-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-exclusive-companions/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/experience-exclusive-companions/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-generic/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "experience-generic",
        stockSessionKey: "experience-generic-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-generic/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/experience-generic/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-exclusive/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "experience-exclusive",
        stockSessionKey: "experience-exclusive-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/experience-exclusive/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/experience-exclusive/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/physiotherapy/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/physiotherapy/no-justification/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/physiotherapy-justification/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/physiotherapy/justification/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/psychology/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/psychology/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/handyman/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/handyman/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/sad/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "sad",
        stockSessionKey: "home-service-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/sad/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/home-service/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/carpentry/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "carpentry",
        stockSessionKey: "carpentry-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/carpentry/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/carpentry/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/gardening/check-availability",
    data: {
      title: "routeTitles.serviceAvailability",
      flowConfig: {
        formSegment: "gardening",
        stockSessionKey: "gardening-stock-quantity"
      }
    },
    loadChildren: () => import("./_modules/services/availability/availability.module").then( m => m.AvailabilityPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/gardening/form",
    data: { title: "routeTitles.serviceRequest" },
    loadChildren: () => import("./_modules/forms/gardening/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/coque/form",
    data: { title: "routeTitles.coqueForm" },
    loadChildren: () => import("./_modules/forms/coque/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: ":locale/service-request/:id/traga-luz/form",
    data: { title: "routeTitles.tragaLuzForm" },
    loadChildren: () => import("./_modules/forms/traga-luz/form.module").then( m => m.FormPageModule),
    canActivate: [AuthGuard, FlowNavigationGuard]
  },
  {
    path: "**",
    redirectTo: "/" + environment.defaultLang,
    pathMatch: "full"
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
